<template>
  <div class="wrapper">
    <div class="wrapA">
      <a
        style="display: block"
        :href="images.dirlink"
        class="hengfu"
        v-if="images.type && images.type === 1"
      >
        <object data="" type="">
          <embed
            style="width: 1200px; height: 100px"
            :src="smAds[3].logo"
            type=""
          />
        </object>
      </a>
      <a style="display: block" :href="images.dirlink" class="hengfu">
        <img style="width: 1200px; height: 100px" :src="images.logo" alt="" />
      </a>

      <div class="news-wrap">
        <NewsTab
          :title1="newsArr[3]"
          :newsClass_1="newsClass[3]"
          :cate_id1="newsCate[3]"
        ></NewsTab>
        <NewsTab
          :title1="newsArr[4]"
          :newsClass_1="newsClass[4]"
          :cate_id1="newsCate[4]"
        ></NewsTab>
        <NewsTab
          :title1="newsArr[5]"
          :newsClass_1="newsClass[5]"
          :cate_id1="newsCate[5]"
        ></NewsTab>
        <NewsTab
          :title1="newsArr[6]"
          :newsClass_1="newsClass[6]"
          :cate_id1="newsCate[6]"
        ></NewsTab>
        <NewsTab
          :title1="newsArr[7]"
          :newsClass_1="newsClass[7]"
          :cate_id1="newsCate[7]"
        ></NewsTab>
        <slot></slot>
      </div>

      <!--行业预警-->
      <zhitongche></zhitongche>

      <div class="hejie-wrap">
        <div class="hejie-daren" style="position: relative">
          <div class="daren">
            |
            <span style="color: white; background: #446291; padding: 0 10px">
              七日热投诉 </span
            >&nbsp;|
          </div>
          <swiper :options="swiperOptionB">
            <swiper-slide v-for="(item,idx) in talent" :key="idx">
              <div class="img-wrap" :title="item.detail">
                <div @click="toArticle(item.id)">
                  <img class="lawyer" :src="item.logo" alt="" />
                  <div v-text="item.title"></div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div
            class="swiper-button-prev change-btn-3"
            slot="button-prev1"
            style="
              margin-left: -30px;
              z-index: 999;
              position: absolute;
              top: 126px;
              left: 40px;
            "
          ></div>
          <div
            class="swiper-button-next change-btn-4"
            slot="button-next1"
            style="
              margin-left: -30px;
              z-index: 999;
              position: absolute;
              top: 126px;
              right: 9px;
            "
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewsTab from "@/components/NewsTab.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import zhitongche from "@/components/zhitongche.vue";

export default {
  name: "HejieSwiper",
  components: {
    NewsTab,
    swiper,
    swiperSlide,
    zhitongche,
  },

  data() {
    return {
      newsClass: [],
      newsArr: [],
      newsCate: [],
      train: "",
      talent: "",
      images: "",

      swiperOptionB: {
        slidesPerView: 7,
        spaceBetween: 15,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".change-btn-4",
          prevEl: ".change-btn-3",
        },
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
      },
    };
  },
  methods: {
    toArticle(id) {
      this.$router.push({
        path: "/HejieDaren",
        query: { artId: id, title: "和解达人" },
      });
    },
    // 获取和解企业&律师
    getTrain() {
      this.$get("/index/index/through_train")
        .then((res) => {
          if (res.code === 0) {
            this.train = res.data.train;
            this.talent = res.data.talent;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    guangGao() {
      this.$get("/index/index/ad_position")
        .then((res) => {
          if (res.code === 0) {
            this.images = res.data.images[3];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getNewsClass() {
      this.$get("/index/index/complaint_list")
        .then((res) => {
          if (res.code === 0) {
            for (let k in res.data) {
              this.newsArr.push(k);
              this.newsClass.push(res.data[k]);
              this.newsCate.push(res.data2[k]);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getTrain();
    this.getNewsClass();
    this.guangGao();
  },
};
</script>

<style scoped lang="less">
.wrapA {
  width: 1200px;
  margin: 0 auto;
}

.hengfu > img {
  width: 1200px;
  height: 100px;
  margin: 15px 0;
}

.swiper-img {
  width: 230px;
  height: 140px;
  -o-object-fit: cover;
  object-fit: cover;
}

.news-wrap {
  display: flex;
  flex-wrap: wrap;
}

.zhitongche {
  max-width: 1200px;
  max-height: 255px;
  background: #ecf3ff;
  padding: 22px;

  /deep/ .swiper-wrapper {
    transition-timing-function: linear !important;
  }
}

.daren {
  width: 230px;
  text-align: center;
  height: 26px;
  font-size: 20px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  line-height: 26px;
  margin: 20px 0 16px 460px;
  color: white;
}

.img-wrap {
  text-align: center;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: rgba(51, 51, 51, 1);
  line-height: 19px;
  margin: 0 10px;
  cursor: pointer;
}

.hejie-daren {
  max-height: 255px;
  height: 241px;
  border: 1px solid #ecf3ff;
  margin-top: 40px;
  padding: 0 47px;
}

.daren {
  font-size: 20px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: #294b7f;
}

.lawyer {
  border-radius: 50%;
  height: 128px;
  width: 128px;
  object-fit: cover;
}

.swiper-container {
  right: 6px;
}

.swiper-button-prev {
  background-image: url("../assets/image/arrow_left.png");
}

.swiper-button-next {
  background-image: url("../assets/image/arrow_right.png");
}

/*.hejie-wrap {*/
/*padding: 0 25px;*/
/*border*/
/*}*/
</style>
